import * as React from "react"

import reportError from "./report-error"

interface Props {
  fallback: React.ReactNode
}

interface State {
  error: Error | null
}

export default class ReportingErrorBoundary extends React.Component<
  Props,
  State
> {
  public constructor(props: Props) {
    super(props)
    this.state = { error: null }
  }

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { error }
  }

  public componentDidCatch(error: Error): void {
    // You can also log the error to an error reporting service
    reportError(error)
  }

  public render(): React.ReactNode {
    if (this.state.error) {
      // Fallback UI in case of error,
      return this.props.fallback
    }

    return this.props.children
  }
}
